import errorReducer from 'reducers/error/reducer';

const { actions, reducer } = errorReducer;

export const errorActions = actions;

export default reducer;
